import { render, staticRenderFns } from "./CollectionFollowResultPerformance.vue?vue&type=template&id=eb37fe48&scoped=true"
import script from "./CollectionFollowResultPerformance.vue?vue&type=script&lang=js"
export * from "./CollectionFollowResultPerformance.vue?vue&type=script&lang=js"
import style0 from "./CollectionFollowResultPerformance.vue?vue&type=style&index=0&id=eb37fe48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb37fe48",
  null
  
)

export default component.exports